import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-after-complete-delivery-and-threshold-form-body",
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule],
  templateUrl:
    "./after-complete-delivery-and-threshold-form-body.component.html",
  styleUrls: [
    "./after-complete-delivery-and-threshold-form-body.component.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AfterCompleteDeliveryAndThresholdFormBodyComponent {
  @Input() userName = "there";
  @Input() momentStep = "afterCompleteDeliveryAndThresholdForm";
  @Output() continue = new EventEmitter<void>();

  onContinue(): void {
    this.continue.emit();
  }
}
